import React, { useEffect } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
import { CircularProgress } from '@mui/material';
import usePrequal from '../../resources/prequal/usePrequal';
import useOffer from '../../resources/offer/read';
import Screen from '../Screen';
import Disclaimers from '../Disclaimers';

const OfferPoll = () => {
  const { showBoundary } = useErrorBoundary();
  const {
    data: prequal,
    mutate: mutatePrequal,
  } = usePrequal();
  useOffer(prequal.id, { onSuccess: () => mutatePrequal() });

  useEffect(() => {
    const timeoutId = setTimeout(() => showBoundary(), 15_000);
    return () => clearTimeout(timeoutId);
  }, [showBoundary]);

  return (
    <Screen
      header="Congratulations, you've prequalified!"
      subheader="Please wait while your information is reviewed. A decision will be provided in a few moments."
    >
      <CircularProgress />
      <Disclaimers textAlign="center">
        Do not click the back button or close your browser
        while your information is being processed.
      </Disclaimers>
    </Screen>
  );
};
export default OfferPoll;
